import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class DataEncryptService {

  private key: string = 'MIIBOgIBAAJBAIzvb4tbyWKLaotFcUyNi38q4IUxs0wgFpoER7T02wypOoekQ5BtcYlrBjESoT6QePNQG7Bj0QARdTo80gH+NuUCAwEAAQJBAIjKCHCxWMhN2s5sSyhrJZ77BcohUA4uAuHgD50iHs2sq73RCHUfY6jOgOzQfNRvMu';

  private CryptoJSAesJson = {
    stringify: function (cipherParams: any) {
      const j: any = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
      if (cipherParams.iv) j.iv = cipherParams.iv.toString();
      if (cipherParams.salt) j.s = cipherParams.salt.toString();
      return JSON.stringify(j);
    },
    parse: function (jsonStr: any) {
      const j: any = JSON.parse(jsonStr);
      const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams;
    }
  };

  constructor() { }

  public getEncrypt(cadena): string {
    return CryptoJS.AES.encrypt(JSON.stringify(cadena), this.key, { format: this.CryptoJSAesJson }).toString();
  }

  public getDescrypt(cadena): any {
    const cadenaDescrypt = CryptoJS.AES.decrypt(cadena, this.key);
    return JSON.parse(cadenaDescrypt.toString(CryptoJS.enc.Utf8));
  }
}
